import { callRpc } from './base';
import { ensureObject } from './util';

export interface UpdateProgramMediaParams {
  program_id: string;
  website_url?: string | null;
  submission_url?: string | null;
  past_winners_url?: string | null;
  logo_url?: string | null;
  website_screenshot_url?: string | null;
  seed_urls?: string | null;
  wikipedia_entry?: string | null;
  // Specialized URLs discovered by URL-Validator agent
  categories_url?: string | null;
  deadlines_url?: string | null;
  fees_url?: string | null;
  requirements_url?: string | null;
  contact_url?: string | null;
  guidelines_url?: string | null;
  // QC flags
  qc_flag_media?: boolean | null;
  qc_flag_media_notes?: string | null;
  editor_id?: string | null;
}

export interface UpdateProgramMediaResult {
  program_id: string;
  program_code: string;
  updated_at: string;
  changes: Record<string, { before: unknown; after: unknown }>;
  media_id: string;
}

/**
 * Update media/URL information for a program
 */
export async function updateProgramMedia(
  params: UpdateProgramMediaParams
): Promise<UpdateProgramMediaResult> {
  return await callRpc('update_program_media', {
    params: {
      p_program_id: params.program_id,
      p_website_url: params.website_url,
      p_submission_url: params.submission_url,
      p_past_winners_url: params.past_winners_url,
      p_logo_url: params.logo_url,
      p_website_screenshot_url: params.website_screenshot_url,
      p_seed_urls: params.seed_urls,
      p_wikipedia_entry: params.wikipedia_entry,
      p_categories_url: params.categories_url,
      p_deadlines_url: params.deadlines_url,
      p_fees_url: params.fees_url,
      p_requirements_url: params.requirements_url,
      p_contact_url: params.contact_url,
      p_guidelines_url: params.guidelines_url,
      p_qc_flag_media: params.qc_flag_media,
      p_qc_flag_media_notes: params.qc_flag_media_notes,
      p_editor_id: params.editor_id
    },
    transform: (payload) =>
      ensureObject<UpdateProgramMediaResult>(
        payload,
        'INVALID_UPDATE_MEDIA_RESPONSE',
        'update_program_media RPC returned invalid data',
        { program_id: params.program_id }
      ),
    successMeta: (result) => ({
      program_id: params.program_id,
      changed_fields: Object.keys(result.changes).length
    })
  });
}
